import React from "react";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { SharedExerciseCard } from "@sophy/shared-ui";
import {
  parseExerciseSteps,
  getPrescriptionItems,
  getPlayerLabels,
  getBodyRegionTags,
} from "@features/programs/utils/exerciseCardData";

/**
 * Exercise on the public program page (opened with a program code, no login).
 * Same card as inside the portal so a shared link looks like the app.
 */
function PublicExerciseCard({ exercise, position = null }) {
  const { t } = useTranslation();

  const steps = parseExerciseSteps(exercise?.steps);
  const prescription = getPrescriptionItems(exercise?.prescription, t);

  return (
    <SharedExerciseCard
      title={parse(String(exercise?.name || ""))}
      tags={getBodyRegionTags(exercise?.body_region)}
      /* No video_url means the exercise is a still image; the card then drops
         the player instead of offering a play button that cannot play. */
      videoSrc={exercise?.video_url || null}
      posterSrc={exercise?.thumb_url || null}
      playerLabels={getPlayerLabels(t)}
      badge={position}
      steps={steps}
      showMoreLabel={t("public-program.show-more")}
      showLessLabel={t("public-program.show-less")}
      prescription={
        /* Unknown format: show the string the backend sent rather than
           mislabelling its parts. */
        prescription ||
        (exercise?.prescription ? [{ value: exercise.prescription }] : null)
      }
      note={exercise?.note || null}
    />
  );
}

export default PublicExerciseCard;
